<div class="row">
  <div class="col-lg col-md col-xs col-xl col-sm w-100 sdcCardItem">
    <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
      <div class="row pt-3">
        <div class="col-lg-2 col-md-12 col-xs-12 col-sm-6" *ngIf="btnExcluir">
          <button mat-flat-button color="warn" (click)="delete()" class="sdcBtnSize" matTooltip="Excluir">
            <i class="fa fa-minus fa-1x btnIcon"></i> Excluir
          </button>
        </div>
        <div class="col-lg col-md">
          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
            <mat-label class="InputLabelColor">Peso Debulha (kg)</mat-label>
            <input matInput id="txtPesoDebulha" #txtPesoDebulha maxlength="10" formControlName="Peso_debulha_kg"
              placeholder="NAO INFORMADO" currencyMask [options]="{ thousands: '.', decimal: ',', precision: 1 }"
              (blur)="makeCalculations($event)">
            <i matSuffix class="{{iconEnableField}}"></i>
            <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}
            </mat-hint>
            <mat-hint align="end">{{txtPesoDebulha.value.length}} / 10</mat-hint>
            <mat-error>{{hasErrorFormControl(formulario.controls.Peso_debulha_kg)}}</mat-error>
          </mat-form-field>
        </div>

        <div class="col-lg col-md">
          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
            <mat-label class="InputLabelColor">Lote Ds (Exemplo: ABCDEF1234/A1BCD2345)</mat-label>
            <input matInput id="txtLoteDs" #txtLoteDs maxlength="10" formControlName="Lote_ds"
              placeholder="NAO INFORMADO">
            <i matSuffix class="{{iconEnableField}}"></i>
            <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteDs}}
            </mat-hint>
            <mat-hint align="end">{{txtLoteDs.value.length}} / 10</mat-hint>
            <mat-error>{{hasErrorFormControl(formulario.controls.Lote_ds)}}
            </mat-error>
          </mat-form-field>
        </div>


        <div class="col-lg col-md">
          <mat-form-field class="w-100" appearance="{{formFieldAppearance}}" floatLabel="{{formFieldFloatLabel}}">
            <mat-label class="InputLabelColor">Silo Destino (Exemplo: SB12/BB)</mat-label>
            <input matInput id="txtSiloDestino" #txtSiloDestino maxlength="4" formControlName="Silo_destino"
              placeholder="NAO INFORMADO" (blur)="updateSilo()">
            <i matSuffix class="{{iconEnableField}}"></i>
            <mat-hint align="start" class="InputLabelDetailsColor">{{hintSiloDestino}}
            </mat-hint>
            <mat-hint align="end">{{txtSiloDestino.value.length}} / 4</mat-hint>
            <mat-error>{{hasErrorFormControl(formulario.controls.Silo_destino)}}</mat-error>


          </mat-form-field>
        </div>





      </div>


    </form>
  </div>
</div>